import { parse } from "date-fns";

export interface CompanyFinancialFormType extends Omit<MyBrokerApi.MoralFiscalFinancialForm, "endOfFiscalYear"> {
    endOfFiscalYear: Date; //ddMM
}

export const companyFinancialDefaultValues = (
    defaultValues: MyBrokerApi.MoralFiscalFinancial = {},
): CompanyFinancialFormType => {
    const { fiscalStatus, endOfFiscalYear, vatNumber, vatExemption, bankAccountNumber, billingEmailAddress } =
        defaultValues;
    return {
        fiscalStatus: fiscalStatus?.id || "",
        endOfFiscalYear: endOfFiscalYear ? parse(endOfFiscalYear, "ddMM", new Date()) : null,
        vatNumber: vatNumber || "",
        vatExemption: vatExemption || null,
        bankAccountNumber: bankAccountNumber || "",
        billingEmailAddress: billingEmailAddress || "",
    };
};

export const companyFinancialFixture = (): CompanyFinancialFormType => ({
    fiscalStatus: "30",
    endOfFiscalYear: new Date(2022, 2, 2),
    vatNumber: "VAT123ABC",
    vatExemption: 3,
    bankAccountNumber: "1234ABCDEBANK",
    billingEmailAddress: "john@email.com",
});
